import React from 'react';
import Smallbanner from '../images/Made_in_india_PC.jpg';
import '../css/checkout.css';
import Subtotal from './subtotal';

function Checkout(){
    return(
          <section>
              <div className="checkout">
                    <div className="checkout-left">
                        <div className="checkout-left-box">
                        <div className="smallbanner">
                            <img src={Smallbanner} alt="smallbanner" />
                        </div>
                        <h1 className="shoping-basket">Your Shoping Basket</h1>
                        <hr className="line-breaker"></hr>
                        </div>
                    </div>
                    <div className="checkout-right">
                       <div className="checkout-right-box">
                           <Subtotal />
                       </div>
                    </div>
              </div>
          </section>
        
    )
}

export default Checkout;